<template>
  <component
    :is="name"
    v-if="loading || showIntro || serviceUnavailable"
    :key="`storage${$route.name}${loading}`"
    :service-requested="serviceRequested"
    name="Storage"
  />
  <router-view v-else />
</template>
<script>
const StorageIntro = () => import('./StorageIntro.vue')
const RequestService = () => import('@/components/start/RequestService.vue')

export default {
  name: 'Compute',
  components: { StorageIntro, RequestService },
  computed: {
    name() {
      if (this.showIntro) return 'storage-intro'
      if (this.serviceUnavailable) return 'request-service'
      return 'loading-page'
    },
    showIntro() {
      return this.$store.state.buckets.showIntro
    },
    serviceUnavailable() {
      return this.$store.state.buckets.serviceUnavailable
    },
    serviceRequested() {
      return this.$store.state.buckets.serviceRequested
    },
    loading() {
      return false
    },
  },
  created() {
    this.$store.commit('buckets/SET_SHOW_INTRO', false)
  },
}
</script>
